var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "appointment-base" } }, [
    _c(
      "div",
      {
        staticClass:
          "sticky top-18 z-10 px-6 h-12 flex-shrink-0 flex items-center justify-between gap-y-2 gap-x-4 bg-pure-white border-b border-slate-400"
      },
      [_c("BlBreadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })],
      1
    ),
    _vm._v(" "),
    _vm.pageLoading
      ? _c("div", { staticClass: "h-128 w-full grid place-items-center" }, [
          _c("div", { staticClass: "blum-loader" })
        ])
      : _c("div", { staticClass: "w-full p-6 flex justify-center" }, [
          _c(
            "div",
            {
              staticClass: "bg-pure-white w-full",
              style: { maxWidth: "62.5rem" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "border border-slate-400 py-4 px-6 flex flex-col gap-1"
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _vm.isOrphan
                        ? _c("BlChip", {
                            attrs: {
                              chip: "Orphan Appointment",
                              color: "tomato"
                            }
                          })
                        : _c("BlChip", {
                            attrs: { chip: "" + _vm.appointment.status }
                          })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.appointment.client && _vm.appointment.client.name
                    ? _c("BlTextTitle4", {
                        attrs: { text: _vm.appointment.client.name }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: { text: "Session scheduled for " + _vm.timeslot }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-160 flex-shrink-0 border border-slate-400 p-6"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-3 gap-4" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-span-3 flex items-center gap-4" },
                          [
                            _c("BlTextSubtitle1", {
                              attrs: { text: "Appointment details" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "col-span-1",
                          attrs: { text: "Appointment ID" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "col-span-2 text-slate-1000",
                          attrs: { text: _vm.appointment.id }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "col-span-1",
                          attrs: { text: "Assigned therapist" }
                        }),
                        _vm._v(" "),
                        _vm.isOrphan
                          ? _c(
                              "div",
                              { staticClass: "col-span-2" },
                              [
                                _c("BlIcon", {
                                  staticClass: "h-4 w-4",
                                  attrs: { icon: "warning", color: "tomato-7" }
                                })
                              ],
                              1
                            )
                          : !_vm.appointment.user
                          ? _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: { text: "-" }
                            })
                          : _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              class: { "italic ": !_vm.appointment.user.name },
                              attrs: {
                                title:
                                  _vm.appointment.user.name || "Deleted user",
                                text:
                                  _vm.appointment.user.name || "Deleted user"
                              }
                            }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "col-span-1",
                          attrs: { text: "Supervisor" }
                        }),
                        _vm._v(" "),
                        !_vm.appointment.supervisors ||
                        !_vm.appointment.supervisors.length
                          ? _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: { text: "-" }
                            })
                          : _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: {
                                text: _vm.appointment.supervisors
                                  .map(function(i) {
                                    return i.name
                                  })
                                  .join(", ")
                              }
                            }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "col-span-1",
                          attrs: { text: "Timeslot" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "col-span-2 text-slate-1000",
                          attrs: { text: _vm.timeslot }
                        }),
                        _vm._v(" "),
                        _vm.enableBranch
                          ? _c("BlTextBody2", {
                              staticClass: "col-span-1",
                              attrs: { text: "Branch" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.enableBranch
                          ? _c(
                              "div",
                              { staticClass: "col-span-2 flex" },
                              [
                                !_vm.appointment.room.branch
                                  ? _c("BlTextBody2", { attrs: { text: "-" } })
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "h-7 max-w-96 px-2 flex items-center justify-center rounded",
                                        style: {
                                          backgroundColor:
                                            _vm.appointment.room.branch
                                              .background_color || "unset"
                                        }
                                      },
                                      [
                                        _c("BlTextBody2", {
                                          staticClass: "truncate",
                                          style: {
                                            color:
                                              _vm.appointment.room.branch
                                                .color || "unset"
                                          },
                                          attrs: {
                                            text:
                                              _vm.appointment.room.branch
                                                .name || "-"
                                          }
                                        })
                                      ],
                                      1
                                    )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "col-span-1",
                          attrs: { text: "Room" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-span-2" },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-slate-1000",
                              attrs: { text: _vm.appointment.room.name }
                            }),
                            _vm._v(" "),
                            _vm.appointment.is_open_room
                              ? _c("BlTextBody2", {
                                  staticClass: "text-slate-1000",
                                  attrs: { text: "(open room)" }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "flex-grow h-px bg-slate-400 my-6"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-3 gap-4" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-span-3 flex items-center gap-4" },
                          [
                            _c("BlTextSubtitle1", {
                              attrs: { text: "Credits details" }
                            }),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to:
                                    "/clients/" +
                                    _vm.appointment.client.id +
                                    "/credit"
                                }
                              },
                              [
                                _c("BlInputButton", {
                                  attrs: {
                                    type: "outlined",
                                    dense: "",
                                    label: "View credits"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "col-span-1",
                          attrs: { text: "Total credits used" }
                        }),
                        _vm._v(" "),
                        !_vm.appointment.credit_transaction_services.length
                          ? _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: { text: _vm.creditsUsed + " credit(s)" }
                            })
                          : _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: {
                                text:
                                  _vm.creditsUsed +
                                  " credit(s) of " +
                                  _vm.appointment.credit_transaction_services[0]
                                    .package_item_name
                              }
                            }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "col-span-1",
                          attrs: { text: "Transaction ID" }
                        }),
                        _vm._v(" "),
                        !_vm.appointment.credit_transaction_services.length
                          ? _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: { text: "-" }
                            })
                          : _c(
                              "div",
                              { staticClass: "col-span-2" },
                              _vm._l(
                                _vm.appointment.credit_transaction_services,
                                function(credit) {
                                  return _c(
                                    "div",
                                    {
                                      key: credit.id,
                                      staticClass:
                                        "px-2 flex items-center gap-2"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "h-1 w-1 flex-shrink-0 bg-slate-800 rounded"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                "ID " +
                                                credit.credit_transaction_id +
                                                ":"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                (credit.session_credit || 0) +
                                                " credit(s)"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.appointment.status === "cancelled"
                      ? _c("div", {
                          staticClass: "flex-grow h-px bg-slate-400 my-6"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.appointment.status === "cancelled"
                      ? _c(
                          "div",
                          { staticClass: "grid grid-cols-3 gap-4" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-span-3 flex items-center gap-4"
                              },
                              [
                                _c("BlTextSubtitle1", {
                                  attrs: { text: "Cancellation details" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-1",
                              attrs: { text: "Cancellation requested by" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: {
                                text:
                                  _vm.appointment.cancellation_requester_type
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-1 truncate",
                              attrs: {
                                text: "Credits deducted for cancellation",
                                title: "Credits deducted for cancellation"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: {
                                text: _vm.appointment.subtract_session_credit
                                  ? "Yes"
                                  : _vm.appointment.subtract_session_credit ===
                                    null
                                  ? "-"
                                  : "No"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-1",
                              attrs: { text: "Cancellation reason" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass:
                                "col-span-2 text-slate-1000 capitalize-first",
                              attrs: { text: _vm.cancellationReasonText }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "flex-grow h-px bg-slate-400 my-6"
                    }),
                    _vm._v(" "),
                    _vm.appointment.session
                      ? _c(
                          "div",
                          { staticClass: "grid grid-cols-3 gap-4" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-span-3 flex items-center gap-4"
                              },
                              [
                                _c("BlTextSubtitle1", {
                                  attrs: { text: "Session details" }
                                }),
                                _vm._v(" "),
                                _vm.appointment.session.slug
                                  ? _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to:
                                            "/session/" +
                                            _vm.appointment.session.slug +
                                            (_vm.appointment.status ===
                                              "scheduled" ||
                                            _vm.appointment.status ===
                                              "booking_in_progress"
                                              ? "/edit"
                                              : "")
                                        }
                                      },
                                      [
                                        _c("BlInputButton", {
                                          attrs: {
                                            type: "outlined",
                                            dense: "",
                                            label: "View session"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-1",
                              attrs: { text: "Session ID" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: { text: _vm.appointment.session.id }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-1",
                              attrs: { text: "Session name" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: {
                                text:
                                  _vm.appointment.session.name ||
                                  "Unnamed session"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-1",
                              attrs: { text: "Conducted by" }
                            }),
                            _vm._v(" "),
                            !_vm.appointment.session.user
                              ? _c("BlTextBody2", {
                                  staticClass: "col-span-2 text-slate-1000",
                                  attrs: { text: "-" }
                                })
                              : _c("BlTextBody2", {
                                  staticClass: "col-span-2 text-slate-1000",
                                  attrs: {
                                    text:
                                      _vm.appointment.session.user.name || "-"
                                  }
                                }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-1",
                              attrs: { text: "Session conducted at" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-2 text-slate-1000",
                              attrs: { text: _vm.sessionConductedAt }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "col-span-1",
                              attrs: { text: "Session duration" }
                            }),
                            _vm._v(" "),
                            !_vm.appointment.session.duration[0]
                              ? _c("BlTextBody2", {
                                  staticClass: "col-span-2 text-slate-1000",
                                  attrs: { text: "-" }
                                })
                              : _c("BlTextBody2", {
                                  staticClass: "col-span-2 text-slate-1000",
                                  attrs: {
                                    text:
                                      _vm.appointment.session.duration[1] || "-"
                                  }
                                })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "w-90 flex-shrink-0 border border-slate-400 p-6"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "mb-4" },
                      [_c("BlTextSubtitle1", { attrs: { text: "Activity" } })],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.appointment.log_activities, function(
                      activity,
                      idx
                    ) {
                      return _c("BlActivity", {
                        key: activity.id,
                        attrs: {
                          activity: activity,
                          isFirst: idx === 0,
                          isLast:
                            idx + 1 === _vm.appointment.log_activities.length
                        }
                      })
                    })
                  ],
                  2
                )
              ])
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a5bf4b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a5bf4b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/Appointment.vue
// module id = null
// module chunks = 